<template>
  <div>
    <v-card
      class="mb-3 px-5 pt-6 pb-6 rounded-xl card-container"
      :elevation="0"
    >
      <div class="total-video-views">
        <p>Total video views</p>
        <span>{{ recordDetails.total_views }}</span>
      </div>
      <!-- <div class="average-completion-rate">
        <p>Average Completion Rate</p>
        <span>100%</span>
      </div> -->
      <!-- <h3>30 Viewers</h3> -->
    </v-card>
  </div>
</template>

<script>
export default {
  name: "Views",
  props: {
    recordDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.card-container {
  text-align: left;
  p {
    margin: 0;
    font-weight: 600;
  }
  span {
    font-size: 24px;
    font-weight: 700;
  }
}
.total-video-views {
  background-color: #c8d8e3;
  border-radius: 8px !important;
  padding: 12px;
  margin-bottom: 12px;
  span {
    font-size: 30px;
  }
}
// .average-completion-rate {
//   background-color: #edf2f7;
//   border-radius: 8px !important;
//   padding: 12px;
//   margin-bottom: 12px;
// }
</style>
